import { apiClientChatting } from '@/utils/axios'

import type { MessageQueue } from '../types'

export const getQueueList = async (creatorId: number) => {
  const res = await apiClientChatting.get<MessageQueue[]>(
    `/of-chat/${creatorId}/queue`,
  )

  return res.data
}

export const queueService = { getQueueList }
